import {
  FETCH_DATA_REQUEST,
  FETCH_DATA_SUCCESS,
  FETCH_DATA_FAILURE,
  FETCH_DATA_PROGRESS,
  FILE_DOWNLOAD_REQUEST,
  FILE_DOWNLOAD_SUCCESS,
  FILE_DOWNLOAD_FAILURE
} from "./constants";

import { IHomeScreen } from "../../../models";

export const fetchHomeScreen = (payload: IHomeScreen) => ({
  type: FETCH_DATA_REQUEST,
  payload
});

export const fetchHomeScreenSuccess = (payload: IHomeScreen) => ({
  type: FETCH_DATA_SUCCESS,
  payload
});

export const fetchHomeScreenFailure = (error: string) => ({
  type: FETCH_DATA_FAILURE,
  payload: { error }
});

export const fetchHomeStatusProgress = (payload: IHomeScreen) => ({
  type: FETCH_DATA_PROGRESS,
  payload
});


export const fetchFileDownLoadRequest = (payload) => ({
  type: FILE_DOWNLOAD_REQUEST,
  payload
});

export const fetchFileDownLoadSuccess = (payload) => ({
  type: FILE_DOWNLOAD_SUCCESS,
  payload
});

export const fetchFileDownLoadFailure = (payload) => ({
  type: FILE_DOWNLOAD_FAILURE,
  payload
});
